/**
 * index.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 모바일 브랜드&분양페이지 Header 렌더링 컴포넌트
 *
 * -----------------------------------------------------------------------------------------------
 */

import useSticky from 'common-modules/general/Modules/custom-hooks/useSticky';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeaderContent from './Content';

const RootContainer = styled.div`
  width: 100%;
  &.touched {
    height: 3.25rem;
  }
`;

const HeaderContainer = styled.header``;

interface Props {
  isOpen: boolean;
  isBanner: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header = observer(({ isOpen, isBanner, setIsOpen }: Props) => {
  const [headerPos, setHeaderPos] = useState<Number>(0);
  const { isTouched } = useSticky({
    stickyElementId: 'header',
    stickyElementStaticContainerId: 'static-container-root-main',
    gap: 1
  });

  useEffect(() => {
    const body = document.getElementsByTagName('body');
    if (isOpen) {
      body[0].classList.add('burgerMenu-open');
    } else {
      body[0].classList.remove('burgerMenu-open');
    }
  }, [isOpen]);

  const handleMenuToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => isScrollHeader());
  }, []);

  const isScrollHeader = () => {
    const header = document.getElementById('headerFixed');
    const SubHeader = document.getElementById('fixedTab2');
    const container = document.getElementById('static-container-root-main');
    const scrollTop = window.pageYOffset;

    if (header && container && SubHeader) {
      const elementClientRect = SubHeader.getBoundingClientRect();
      const windowDefaultView = SubHeader.ownerDocument.defaultView;
      const targetY = elementClientRect.top + (windowDefaultView?.pageYOffset || 0) + 1;
      const overlap = targetY - header.clientHeight;

      if (container) {
        if (scrollTop === 0 || scrollTop <= overlap) {
          setHeaderPos(0);
        } else {
          setHeaderPos(overlap - scrollTop >= -51 ? overlap - scrollTop : -51);
        }
      }
    }
  };


  return (
    <>
      <RootContainer id="static-container-root-main">
        <HeaderContainer id="header">
          <HeaderContent isBanner={isBanner} headerPos={headerPos} isFixed={isTouched} menuFn={handleMenuToggle} />
        </HeaderContainer>
      </RootContainer>
    </>
  );
});

export default Header;
